import React from 'react';
import classnames from 'classnames';
import { Flex, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './AttributeGridError.css';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  tIcon
} = I18N.ns('ui-attributes.attribute.editor.AttributeGridError');
const EMPTY_ERROR = '\u00A0';
export default function AttributeGridError({
  error = EMPTY_ERROR,
  variant,
  highlight
}) {
  const icon = error === EMPTY_ERROR ? null : tIcon('icon');
  return /*#__PURE__*/_jsx(Flex, {
    direction: "column",
    className: classnames(error !== EMPTY_ERROR && S.errorContainer, S.animated, highlight && S.highlight),
    children: Array.isArray(error) ? error.map((err, index) => /*#__PURE__*/_jsx(Text, {
      icon: index === 0 ? icon : undefined,
      variant: variant || 'inputCaptionSmallError',
      children: err
    }, err)) : /*#__PURE__*/_jsx(Text, {
      icon: icon,
      variant: variant || 'inputCaptionSmallError',
      children: error
    })
  });
}